import { IconStyled, IconStylesProps } from './IconStyles';

export const Plus = ({ size = 'base', className = '', fill = 'currentColor' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path xmlns="http://www.w3.org/2000/svg" d="M6.5 2.75H4.25V0.5C4.25 0.223906 4.02609 0 3.75 0H3.25C2.97391 0 2.75 0.223906 2.75 0.5V2.75H0.5C0.223906 2.75 0 2.97391 0 3.25V3.75C0 4.02609 0.223906 4.25 0.5 4.25H2.75V6.5C2.75 6.77609 2.97391 7 3.25 7H3.75C4.02609 7 4.25 6.77609 4.25 6.5V4.25H6.5C6.77609 4.25 7 4.02609 7 3.75V3.25C7 2.97391 6.77609 2.75 6.5 2.75Z" fill={fill} />
    </IconStyled>
);
